import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'
import { Spinner } from "react-bootstrap";
import {
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import { fetchPOST } from '../Api/ApiServices'
import { updateFormField } from "./Slices/formSlice";
import { toastMsg } from "../component/toast";
import SubTopics from "./SubTopics";
import { ShimmerText } from "react-shimmer-effects";
import CustomButton from "../component/button";
import KeywordSkeleton from "../component/skeletons/keywordSkeleton";
export default function Topics() {
  const navigate = useNavigate();
  const maxSelection = 5;

  const [customTopic, setCustOmTopic] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  // const [allSubTopics, setAllSubTopics] = useState([])
  const [subTopics, setSubTopics] = useState([])

  const formData = useSelector((state) => state.form);

  const state = useSelector((state) => state)
  const dispatch = useDispatch()

  // const [topics, setTopics] = useState([])

  const [selectedTopics, setSelectedTopics] = useState([]);

  const handleCheckboxChange = (topic) => {
    console.log(topic)
    const isSelected = formData.topics.includes(topic);

    if (isSelected) {


      dispatch(updateFormField({ field: 'topics', value: formData.topics.filter((t) => t !== topic) }))


    } else {
      if (formData.topics.length < maxSelection) {

        dispatch(updateFormField({ field: 'topics', value: [...formData.topics, topic] }))


      }
    }
  };








  const getTopics = () => {

    dispatch(updateFormField({ field: 'tTopics', value: [] }))
    // dispatch(updateFormField({ field: 'allSubTopics', value: [] }))
    // dispatch(updateFormField({ field: 'customTopics', value:  {} }))

    setIsLoading(true)
    PostCallWithErrorResponse(ApiConfig.GET_TOPISC, {
      "job_description": JSON.stringify({
        "job_description": state?.form?.finalSelectedJobDescription,
        // "job_responsibility": state.form?.finalSelectedResponsibilities,
        "skills": state?.form?.skillsRequiredForJob
      })

    }).then((res) => {

      if (res?.json?.status == 200) {

        console.log(res);

        // setTopics([...res?.json?.sub_topics?.quiz_topics, ...state.form.customTopics.topics])
        dispatch(updateFormField({ field: 'tTopics', value: [...res?.json?.quiz_topics] }))
        // dispatch(updateFormField({ field: 'allSubTopics', value: res?.json?.subtopics }))

        // setAllSubTopics(res?.json?.sub_topics?.subtopics)

      }

      setIsLoading(false)

    })

  }
  const [loadingForCustomSubtopic, setLoadingForCustomSubtopic] = useState(false)

  async function customSubTopics() {
    setLoadingForCustomSubtopic(true);

    const payload = {
      job_description: state?.form?.finalSelectedJobDescription,
      topics: [customTopic]
    };

    try {
      const response = await fetchPOST(
        ApiConfig.GET_CUSTOM_SUB_TOPICS,
        payload
      );

      if (response.status === 200) {
        console.log('formData-->', formData)
        dispatch(updateFormField({ field: 'tTopics', value: [...formData.tTopics, response.quiz_topics] }))
        // dispatch(updateFormField({ field: 'allSubTopics', value: [response.quiz_topics] }))
        handleCheckboxChange(customTopic)
      }
    } catch (err) {

      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);

    } finally {
      setLoadingForCustomSubtopic(false);

    }
  }




  const handleNext = () => {

    if (state.form.topics.length > 0) {
      navigate('/SubTopics')
    } else {
      toastMsg('error', 'Please Select Topics')
    }

  }



  ////////////////////////////////////////////////////////////////////////

  const JOB_DESCRIPTION_STORAGE_KEY = 'prev_job_description'
  const useGetTopicTrigger = () => {
    useEffect(() => {


      const stored = sessionStorage.getItem(JOB_DESCRIPTION_STORAGE_KEY);
      const prevJobDescription = stored ? JSON.parse(stored) : '';

      const hasChanged = prevJobDescription !== formData.finalSelectedJobDescription;
      console.log('hasChanged--', hasChanged)

      if (hasChanged || formData.topics?.length == 0) {

        dispatch(updateFormField({ field: 'topics', value: [] }))
        dispatch(updateFormField({ field: 'subTopics', value: [] }))
        getTopics();
        sessionStorage.setItem(JOB_DESCRIPTION_STORAGE_KEY, JSON.stringify(formData.finalSelectedJobDescription));
      }

      // else: do nothing if keywords are the same

    }, [formData.finalSelectedJobDescription]);
  };

  useGetTopicTrigger()

  return (
    <div
      style={{ backgroundColor: '#F2F4F7' }}
      className={`canLisContentWrap `}
    >

      <div className="t-wrapper-div p-4">
        {/* <h3 className="ja-1">Step 2: Generate Initial Broader Topics</h3> */}
        <div className=" mb-1">
          <h3 className="ja-1 font-color-text">Broader Topics Extracted from JD:</h3>
          <p className="text-base font-color-text pt-1" style={{ marginTop: '-7px' }}>
            <strong>Note:</strong> You can select a maximum of 5 broader topics.
          </p>
        </div>


        <div
          className="do"
          style={{ borderBottom: "1px solid #dcd9d9", paddingBottom: "24px" }}
        >

          <div className="margin-btn-input">
            <p className=" mb-2 font-color-text" style={{ fontSize: "var(--font-size-h4)" }}>
              Add Your Own Broader Topic:
            </p>
            <div className="d-flex gap-3">
              <input
                name="Custom Broader Topic"
                disabled={loadingForCustomSubtopic}
                placeholder="Enter Custom Topic Here"
                value={customTopic}
                onChange={(e) => setCustOmTopic(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter') {

                    if (!customTopic?.length) return

                    const isIn = state.form.customTopics.topics.findIndex((i) => i == customTopic.trim())
                    // const isIn = state?.form?.topics?.length > 0 &&  state?.form?.topics?.findIndex((i) => i == customTopic.trim())
                    // console.log("isIn-->", isIn)
                    if (isIn !== -1) {
                      toastMsg('error', 'Topic Already Added')
                      return
                    }

                    if (state.form.topics.length < maxSelection) {
                      dispatch(updateFormField({ field: 'topics', value: [customTopic.trim(), ...state.form.topics] }))
                    }

                    // setTopics([...topics, customTopic])
                    dispatch(updateFormField({ field: 'tTopics', value: [customTopic.trim(), ...state.form.tTopics] }))

                    dispatch(updateFormField({
                      field: 'customTopics', value: {
                        ...state.form.customTopics,
                        topics: [customTopic.trim(), ...state?.form?.customTopics?.topics]
                      }
                    }))

                    setCustOmTopic('')
                  }
                }}
                className="w-full p-2 rounded-md border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1"
                style={{ width: "30%", height: "37px" }}
              />
              <div>
                <CustomButton
                  isLoading={loadingForCustomSubtopic}
                  disabled={loadingForCustomSubtopic}
                  handleClick={async () => {

                    if (!customTopic.length) return
                    console.log('state.form.customTopics.topics-->', formData.customTopics)
                    const isIn = state.form.customTopics.topics.findIndex((i) => i == customTopic.trim())
                    console.log("isIn-->", isIn)
                    if (isIn !== -1) {
                      toastMsg('error', 'Topic Already Added')
                      return
                    }
                    if (state.form.topics.length < maxSelection) {
                      dispatch(updateFormField({ field: 'topics', value: [customTopic.trim(), ...state.form.topics] }))
                    }

                    // setTopics([...topics, customTopic])
                    dispatch(updateFormField({ field: 'tTopics', value: [customTopic.trim(), ...state.form.tTopics,] }))

                    dispatch(updateFormField({
                      field: 'customTopics', value: {
                        ...state.form.customTopics,
                        topics: [customTopic.trim(), ...state.form.customTopics.topics]
                      }
                    }))

                    setCustOmTopic('')
                  }}
                  title=" Add "
                  buttonType="tertiory"

                />
              </div>
            </div>
          </div>
          <div className="p-1 pt-0">

            <p className="text-style-h4" style={{ ffontWeight: '600'}}>
              Selected Topics: {state.form.topics.length}/{maxSelection}
            </p>

            {
              isLoading ? <>
                <div>
                  <p className='job_size w-100 text-center'> Topics are generating. Please wait <Spinner animation="grow" size='sm' /> </p>
                </div>
                <KeywordSkeleton />
              </> :

                <div className="row" style={{ marginLeft: '2px', marginTop: '-12px' }}>
                  {formData.tTopics.map((topic, index) => (
                    <div key={index} className="form-check  col-md-4">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`topic-${index}`}
                        checked={formData.topics.includes(topic)}
                        onChange={() => handleCheckboxChange(topic)}
                        disabled={
                          state.form.topics.length >= maxSelection &&
                          !state.form.topics.includes(topic)
                        }
                      />
                      <label
                        className="form-check-label form-label margin-btn-input"
                        htmlFor={`topic-${index}`}
                      >
                        {topic}
                      </label>
                    </div>
                  ))}
                </div>
            }
          </div>
        </div>

        <div className="question-modal-footer">
          <CustomButton
            isLoading={false}
            title="Back"
            buttonType='secondary'
            handleClick={() => {

              if (formData?.isAddQuizFromAddCode) {
                navigate(`/addEditGroup/${formData?.tempJobCode}?detailsId=${formData?.jdId}`)

                dispatch(updateFormField({ field: 'isAddQuizFromAddCode', value: false }))

                dispatch(updateFormField({ field: 'jdId', value: "" }))

                return
              }

              if (formData?.isSkippedQuiz) {
                dispatch(updateFormField({ field: 'isSkippedQuiz', value: false }))
                navigate('/')
              } else {
                dispatch(updateFormField({ field: 'step', value: 3 }))
                navigate('/jobDescription')
              }


            }}
          />
          <CustomButton
            title="Submit"
            isLoading={false}
            handleClick={handleNext}
          />
        </div>

      </div>

    </div>


  );
}
